import cn from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/common/Button';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { CmsActionGridItem } from 'src/types/cms/cmsWidgetTypes';
import '../styles.scss';

type Props = {
  widgetData?: CmsActionGridItem | null;
  btnStyles?: string;
  redirect: (action?: CmsCta) => void;
  cls: string;
};
const HomeWidget: FC<Props> = ({ widgetData, btnStyles, redirect, cls }) => {
  const { t }: Translation = useTranslation();
  const imageSrc = widgetData?.image?.path || '';
  if (!imageSrc || imageSrc.includes('undefined')) {
    return <div style={{ color: 'red' }}>Image is broken</div>;
  }
  const redirection = widgetData?.action;

  return (
    <div
      className={cls}
      style={{ backgroundImage: `url("${encodeURI(imageSrc)}")` }}
      onClick={() => redirect(redirection)}
    >
      {!!redirection?.label && (
        <Button className={cn('action-btn', btnStyles)} onClick={() => redirect(redirection)}>
          {redirection?.label || t('goTo')}
        </Button>
      )}
    </div>
  );
};
export default HomeWidget;
